import { createSimpleAction } from '@recruitee/ngrx';

const namespace = 'OffersBrief';

const fetchActiveCollections = createSimpleAction(namespace, 'fetchActiveCollections');
const fetchArchivedCollections = createSimpleAction(namespace, 'fetchArchivedCollections');

const actions = {
  fetchActiveCollections,
  fetchArchivedCollections,
};

export { actions as OffersBriefActions };
